import _ from 'lodash';
import React from 'react';

/**
 * Renders a list of elements formatted as: Primary Value (Secondary Value).
 * @description
 * - Primary value: Plain text.
 * - Secondary value: Parenthesized and styled (typically gray via SCSS).
 * - Fallback: Returns '---' if `fieldValues` is null, undefined, or empty.
 * @param {Array<{value1: any, value2: any}>} fieldValues - Collection of objects to be processed.
 * @example
 * Input: [{ value1: 'ArtistName', value2: 'Remixer' }] -> Output: 'ArtistName (Remixer)'
 * Input: [] -> Output: '---'
 */
export const ObjectValueTypeListView = (fieldValues: any) => {
  if (
    _.isNil(fieldValues) ||
    !_.isArray(fieldValues) ||
    _.isEmpty(fieldValues) ||
    _.every(fieldValues, (field) => _.isNil(field))
  ) {
    return (
      <div className={'read-only-text'}>
        <span className={'read-only-empty-field'}>---</span>
      </div>
    );
  }
  return (
    <div className={'read-only-object-list'}>
      {fieldValues.map((values: any, index) => {
        if (!values) {
          return (
            <div
              key={`empty-value-type-object-${index}`}
              className="read-only-object-list-container"
            >
              <span className={'read-only-empty-field'}>---</span>
            </div>
          );
        }

        const [value, valueType] = Object.values(values) as string[];
        const hasValue = !_.isNil(value) && value !== '';
        const hasValueType = !_.isNil(valueType) && valueType !== '';

        return (
          <div
            key={`${value}-${valueType}-${index}`}
            className="read-only-object-list-container"
          >
            <span
              className={`${hasValue ? 'read-only-object-list-value' : 'read-only-empty-field'}`}
            >
              {hasValue ? value : '---'}
            </span>
            <span
              className={`${hasValueType ? 'read-only-object-list-type' : 'read-only-empty-field'}`}
            >
              {hasValueType ? `(${valueType})` : '---'}
            </span>
          </div>
        );
      })}
    </div>
  );
};
